import React, { useState, useEffect} from "react";
import "../layout/styles/inline-cgos.css";
import "../layout/styles/bootstrap-table.css";
import "../layout/styles/bootstrap-select.min.css";
import { ChequeCultureLegacy } from "./legacyforms/ChequeCultureLegacy";
import { RetourBoutiqueService } from "../service/RetourBoutiqueService";
import { LinkProviderService } from "../service/LinkProviderService";



export const RetourBoutique = () => {
  const [retourPaie, setRetourPaie] = useState(false);
  const [codeCas, setCodeCas] = useState(null);
  

  const retourBoutiqueService = new RetourBoutiqueService();
  const linkService = new LinkProviderService();


  useEffect(() => {
    document.title = "INFORMATIONS PAIEMENT";
    fetchData();
  },[]);

  const formatMontant = (value) => {
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const getCodeCas= (demandeDetail) =>{
    const parts = demandeDetail.split("_");
    if (parts.length >= 4 && /^\d+$/.test(parts[3])) {
      const value = parts[3];
      return value;
    }
  }


  const fetchData = () => {
    const numeroDemandeDetail = localStorage.getItem('numeroDemandeDetail');
    setCodeCas(getCodeCas(numeroDemandeDetail));
    const numcgos = localStorage.getItem('numcgos');
    if ((numeroDemandeDetail !== undefined && numeroDemandeDetail !== null) &&
        (numcgos !== undefined && numcgos !== null)) {
          retourBoutiqueService.retourBoutiqueWithParams(numeroDemandeDetail,numcgos).then((res) => {
                loadFormData(res.data);
              });
     }
  };

  const loadFormData = (data) => {
    setRetourPaie(data);
  };
    const  paiementValide =retourPaie.statutPaiement;
    const  paiementErreur =retourPaie.statutPaiement;  
    const  paiementInterrompu =retourPaie.statutPaiement;
    let content;
    if(paiementValide === 'PAIEMENT VALIDE'){
      content = <div class="alert alert-success" role="alert"><h3 style={{color: "#307039",fontWeight: "bold"}} >{retourPaie.statutPaiement}</h3>
     <p>Nous accusons réception de votre paiement de {formatMontant(retourPaie.montantPrestation)} euros. <br/>
        <br/>
        Si vous avez commandé des <b>{codeCas === "3710" ? "E-titres culture," : codeCas === "3952" ? "e-CESU Multiservices," : ""}</b>
        <ul>
          <li>{codeCas === "3710" ? "Vous allez recevoir sous 24 heures un email vous donnant accès au site web Pluxee où vos E-titres auront été crédités." : codeCas === "3952" ? "Après la commande mensuelle du C.G.O.S, UPCOOP vous enverra un email avec les accès à votre compte en ligne où seront crédités les e-CESU Multiservices." : ""}</li>
          <li>Si vous ne recevez pas d'email, vérifiez les SPAM de votre messagerie. </li>
        </ul>

        <br/>
        Si vous avez commandé des <b>{codeCas === "3710" ? "Titres culture papier," : codeCas === "3952" ? "CESU Multiservices papier," : ""}</b>
        <ul>
        <li>Votre commande sera expédiée à votre adresse postale dans un délai de 4 à 6 semaines.</li>
        </ul>

        <br/>
        <a href={linkService.getRetourEaMembreSuiviDemande()}><h4 style={{color: "rgb(70, 77, 78)",fontWeight: "bold"}} >Cliquez ici pour RETOURNER SUR L'ESPACE AGENT</h4></a>
    </p></div>;
    }
    if(paiementErreur === 'PAIEMENT EN ERREUR'){
      content = <div class="alert alert-danger" role="alert"><h3 style={{color: "#A44E46",fontWeight: "bold"}}>PAIEMENT INTERROMPU</h3>
      <p>
        Le paiement de votre participation n'a pas abouti. <br/>
        Nous vous remercions de renouveler le règlement de votre participation, au plus tard le <b>{retourPaie.datePaiement}</b> . Passé cette date, votre demande de prestation sera annulée. <br/>
        Suivez ce <a href={linkService.getRetourEaMembreSuiviDemande()} > lien vers la rubrique MES SUIVIS – DEMANDES </a> pour procéder au paiement. <br/><br/>
        <b>Vous rencontrez un problème pour finaliser votre paiement ?</b> <br/><br/>
        <a href="https://www.cgos.info/_files/actualites/1793/aide_paiement%201.pdf" target="_blank">Cliquez ici pour l'AIDE POUR LES PAIEMENTS</a>
      </p></div>;
    }
    if(paiementInterrompu === 'PAIEMENT INTERROMPU'){
      content = <div class="alert alert-info" role="alert"><h3 style={{color: "#4F6E7E",fontWeight: "bold"}}>{retourPaie.statutPaiement}</h3>
      <p>Le paiement de votre participation n'a pas abouti. <br/>
      Nous vous remercions de renouveler le règlement de votre participation, au plus tard le <b>{retourPaie.datePaiement}</b>. Passé cette date, votre demande de prestation sera annulée.<br/>
      Suivez ce <a href={linkService.getRetourEaMembreSuiviDemande()} > lien vers la rubrique MES SUIVIS – DEMANDES </a> pour procéder au paiement.
      </p></div>;
    }
  return (
    
    <div class="cld-width" style={{marginTop:"10px"}}>
      <ChequeCultureLegacy/>
      {content}
    </div>
  );
};
